import { Injectable } from '@angular/core';

import { LocalStorageService } from 'app/services/storage/local-storage.service';
import { UserService } from 'app/user/user.service';


@Injectable()
export class PersonalizedLocalStorageService {
    constructor(private _localStorageService: LocalStorageService,
                private _userService: UserService) {
    }

    getJson(key: string) {
        return this._localStorageService.getJson(this._createKey(key));
    }

    setJson(key: string, value: any) {
        this._localStorageService.setJson(this._createKey(key), value);
    }

    private _createKey(key: string) {
        return this._userService.user.email + key;
    }
}